const state = {
    question: {},
    openDropdownForQuestionId: null,
    openModuleDropdownPosition: '',
    updatedModule: {},

    meta: {
        intro_text: '',
        question_count_zones: []
    },
    template: {},
    skipLogic: {},
    savingInProgress: false,
    warning: '',

    openModuleCount: 0,
}

const mutations = {
    SET_QUESTION: (state, question) => {
        Vue.set(state, 'question', question);
    },
    SET_OPEN_QUESTION_DROPDOWN_ID: (state, questionId) => {
        Vue.set(state, 'openDropdownForQuestionId', questionId);
    },
    SET_OPEN_MODULE_DROPDOWN_POSITION: (state, position) => {
        Vue.set(state, 'openModuleDropdownPosition', position);
    },
    SET_UPDATED_MODULE: (state, module) => {
        Vue.set(state, 'updatedModule', module);
    },
    SET_TEMPLATE_META: (state, meta) => {
        Vue.set(state, 'meta', meta);
    },
    SET_TEMPLATE: (state, template) => {
        Vue.set(state, 'template', template);
    },
    SET_TEMPLATE_SKIP_LOGIC: (state, skipLogic) => {
        Vue.set(state, 'skipLogic', skipLogic);
    },
    SET_SAVING: (state, savingInProgress) => {
        Vue.set(state, 'savingInProgress', savingInProgress);
    },
    SET_WARNING: (state, warning) => {
        Vue.set(state, 'warning', warning);
    },
    SET_OPEN_MODULE_COUNT: (state, openModuleCount) => {
        Vue.set(state, 'openModuleCount', openModuleCount);
    },
}

const getters = {
    GET_QUESTION: (state) => state.question,
    GET_OPEN_QUESTION_DROPDOWN_ID: (state) => state.openDropdownForQuestionId,
    GET_OPEN_MODULE_DROPDOWN_POSITION: (state) => state.openModuleDropdownPosition,
    GET_UPDATED_MODULE: (state) => state.updatedModule,
    GET_TEMPLATE_META: (state) => state.meta,
    GET_TEMPLATE: (state) => state.template,
    GET_TEMPLATE_INTRO_TEXT: (state) => state.meta.intro_text,
    GET_TEMPLATE_QUESTION_COUNT: (state) => state.meta.question_count_zones,
    GET_TEMPLATE_SKIP_LOGIC: (state) => state.skipLogic,
    GET_SAVING: (state) => state.savingInProgress,
    GET_WARNING: (state) => state.warning,
    GET_OPEN_MODULE_COUNT: (state) => state.openModuleCount,
}

export default {
    state,
    mutations,
    getters
}